import React, { Component } from 'react';

export default class ChatComponent extends Component {
  render() {
    return <div>ChatComponent</div>;
  }
}
